/* eslint-disable */
import axios from "axios";
/**
 * 定义请求常量
 * TIME_OUT、ERR_OK
 */
// import { urls } from './api/home'
// let url = urls
export const TIME_OUT = 88888888; // 请求超时时间
export const ERR_OK = "0"; // 请求成功返回状态，字段和后台统一
export const ERR_RELOGIN = 401; //重新登录状态
export const BASE_URL = process.env.BASE_URL; // 引入全局url，定义在全局变量process.env中，值为空字符串
export const BASE_TOKEN = process.env.BASE_TOKEN; // 引入全局url，定义在全局变量process.env中，值为空字符串
// export const HOST_URL = process.env.HOST_URL; // 引入全局url，定义在全局变量process.env中，值为空字符串
export const token = localStorage.getItem("token");
import router from "../router";
// 请求超时时间
axios.defaults.timeout = TIME_OUT;
import ElementUI from "element-ui";
import resetMessage from "../assets/js/resetMessage";
// 封装请求拦截
axios.interceptors.request.use(
  config => {
    config.headers["Content-Type"] = "application/json;charset=UTF-8";
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 封装响应拦截，判断token是否过期
axios.interceptors.response.use(
  response => {
    //拦截器状态
    if (localStorage.getItem("xpschoolId")) {
      return response;
    } else {
      if (response.data.code == "90007") {
        // if (router.currentRoute.path == "/login") return false;
        ElementUI.MessageBox.alert("登录已失效，请重新登录！", {
          confirmButtonText: "确定",
          callback: action => {
            window.location.href = BASE_TOKEN;
            // router.replace({
            //   path: "/login"
            // });
          }
        });
        return false;
      } else if (
        response.data.code == "0" ||
        response.data.code == "200" ||
        response.data.code == "201" ||
        response.data.dataList !== undefined
      ) {
        // alert(response.data.code)
        Interceptor(response.data.code);
        return response;
      } else {
        resetMessage({
          message: response.data.msg
        });
        return false;
      }
    }
  },
  error => {
    resetMessage({
      message: "请求失败"
    });
    return false;
  }
);

//拦截器状态
function Interceptor(i) {
  switch (i) {
    case 401:
      localStorage.clear();
      location.href = "/";
      break;
  }
}

export default axios;
// 封装post请求(requestUrl：域名公共部分,params：参数列表type:token类型ctype:上传数据格式类型)
export function POST(requestUrl, params = "", post, type, ctype) {
  //请求方式
  let method = post ? post : "post";

  //默认登录token
  let token = window.localStorage.getItem("token");
  let roleType =
    window.localStorage.getItem("roleId") == "-1004" ? "school" : "teacher";
  //token类型
  switch (type) {
    case 1: //注册token
      token = window.localStorage.getItem("token");
      break;
  }
  token = token != null ? token : "";
  //post请求
  if (method == "post") {
    //设置Content-Type
    if (ctype == 1) {
      return axios({
        url: requestUrl,
        method: method,
        data: params,
        headers: {
          token: token,
          "Content-Type": ctype,
          appCode: "JSYUEDU",
          roleType: roleType
        }
      });
    } else if (ctype == 2) {
      return axios({
        url: requestUrl,
        method: method,
        params: params,
        headers: {
          token: token,
          appCode: "JSYUEDU",
          roleType: roleType
        }
      });
    } else if (ctype == 4) {
      return axios({
        url: requestUrl,
        method: method,
        params: params,
        headers: {
          token: token,
          "Content-Type": "multipart/form-data",
          appCode: "JSYUEDU",
          roleType: roleType
        }
      });
    } else if (ctype == 3) {
      return axios({
        url: requestUrl,
        method: method,
        params: params,
        responseType: "blob",
        headers: {
          token: token,
          appCode: "JSYUEDU",
          roleType: roleType
        }
      });
    } else {
      return axios({
        url: requestUrl,
        method: method,
        data: params,
        headers: {
          token: token,
          appCode: "JSYUEDU",
          roleType: roleType
        }
      });
    }
  } else {
    //get请求
    return axios({
      url: requestUrl,
      method: method,
      params: params,
      headers: {
        token: token,
        appCode: "JSYUEDU",
        roleType: roleType
      }
    });
  }
}
export function DWON(url, method, data) {
  let Loading;
  Loading = ElementUI.Loading.service({
    fullscreen: true,
    text: "数据处理中，请稍后！！！"
  });
  let roleType =
    window.localStorage.getItem("roleId") == "-1004" ? "school" : "teacher";
  //默认登录token
  let token = window.localStorage.getItem("token");
    var xhr = new XMLHttpRequest();
    xhr.open(method.toUpperCase(), url, true); // 也可以使用POST方式，根据接口
    xhr.responseType = "blob"; // 返回类型blob
    xhr.setRequestHeader("token", token);
    xhr.setRequestHeader("roleType", roleType);
    xhr.setRequestHeader("appCode", "JSYUEDU");
    // 发送ajax请求
    xhr.send();
    xhr.onload = function () {
      let that = this;
      // 请求完成
      if (this.status == 200) {
        // 返回201
        if (this.response.size < 200) {
          resetMessage({
            message: "暂无数据"
          });
          Loading.close();
          return false;
        }
        var blob = this.response;
        var reader = new FileReader();
        reader.readAsDataURL(blob); // 转换为base64，可以直接放入a标签href
        reader.onload = function(e) {
          // 转换完成，创建一个a标签用于下载
          var a = document.createElement("a");
          if (that.getResponseHeader("Content-Disposition")) {
            let fileName =
              that
                .getResponseHeader("Content-Disposition")
                .split(";")[1]
                .split("=")[1] || "";
            fileName = revertUTF8(fileName);
            a.download = fileName;
          } else {
            a.download = data + ".xlsx";
          }
          a.href = e.target.result;
          // 修复firefox中无法触发click
          a.click();
        };
        Loading.close();
      }
    };
}
// UTF8编码转成汉字字符串
function revertUTF8(szInput) {
  var x, wch, wch1, wch2, uch = "", szRet = "";
  for (x = 0; x < szInput.length; x++) {
    if (szInput.charAt(x) == "%") {
      wch = parseInt(szInput.charAt(++x) + szInput.charAt(++x), 16);
      if (!wch) { break; }
      if (!(wch & 0x80)) {
        wch = wch;
      } else if (!(wch & 0x20)) {
        x++;
        wch1 = parseInt(szInput.charAt(++x) + szInput.charAt(++x), 16);
        wch = (wch & 0x1F) << 6;
        wch1 = wch1 & 0x3F;
        wch = wch + wch1;
      } else {
        x++;
        wch1 = parseInt(szInput.charAt(++x) + szInput.charAt(++x), 16);
        x++;
        wch2 = parseInt(szInput.charAt(++x) + szInput.charAt(++x), 16);
        wch = (wch & 0x0F) << 12;
        wch1 = (wch1 & 0x3F) << 6;
        wch2 = (wch2 & 0x3F);
        wch = wch + wch1 + wch2;
      }
      szRet += String.fromCharCode(wch);
    } else {
      szRet += szInput.charAt(x);
    }
  }
  return (szRet);
}



// WEBPACK FOOTER //
// ./src/api/index.js